module.exports = __webpack_public_path__ + "static/media/two_lady_02.67891466.png";